import LineItem, { LineItemFromJson } from './LineItem'

export interface BillFromJson {
  total: string
  line_items: LineItemFromJson[]
}

class Bill {
  total: string
  lineItems: LineItem[]

  constructor (total: string, lineItems: LineItem[]) {
    this.total = total
    this.lineItems = lineItems
  }

  static fromJson ({ line_items = [], total }: BillFromJson) {
    return new Bill(
      total,
      line_items.map((lineItem) => LineItem.fromJson(lineItem))
    )
  }
}

export default Bill
